<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-formulario #ctrl URL="inscripcion" titulo="Inscripcion" [dato]="dato"></app-formulario>

<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>

<form name="form" novalidate [formGroup]="dato">
    <div class="contenedor columns " style=" overflow-y:auto; overflow-x: hidden; height:94vh;">

        <!-- apartado de movimientos_articulos -->
        <div class="column" style="padding:0em;">
            <div style="background: #FFF; border-radius: 0em; ">

                <section class="hero is-primary">
                    <div class="hero-body">
                        <nav class="level ">
                            <!-- Left side -->
                            <div class="level-left ">
                                <div class="level-item">
                                    <p class="title" *ngIf="!tieneid">
                                        <span *ngIf="!ctrl.cargando || !cargando" class="icon is-medium">
                                            <i class="icon-edit-1"></i>
                                        </span>
                                        Buscar alumnos preinscritos
                                    </p>
                                    <p class="title" *ngIf="tieneid">
                                      <span *ngIf="!ctrl.cargando || !cargando" class="icon is-medium">
                                        <i class="icon-edit-1"></i>
                                      </span>
                                      Datos del alumno inscrito <strong >(Pago completado: {{ ctrl.dato.get('pago_completado').value ? 'Si' : 'No' }}, Total Abonado: {{preinscripciones.planes_pagos?.total_abonado | currency:ctrl.configuracion.sucursal.moneda}})</strong>
                                    </p>
                                </div>
                                <div class="level-item" style=" width: 100%; " *ngIf="!tieneid">
                                    <div class="control has-icons-left is-expanded" *ngIf="!codigo_barras_activo" style=" width: 100%; ">
                                        <input autofocus autocomplete="off" ngui-auto-complete [source]="observableSource.bind(this)" [list-formatter]="autocompleListFormatter" [close-on-focusout]="false"
                                            id='buscarArticulo' value-property-name="id" display-property-name="id" path-to-data=""
                                            loading-text="Cargando..." no-match-found-text="No hay resultados." (valueChanged)="select_articulo_autocomplete($event)"
                                            min-chars="3" class="input is-success is-medium" type="text" placeholder="Escribe el nombre del alumno, o el folio de preinscripcion">
                                        <span class="icon is-medium is-left">
                                            <i class="icon-search3"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </nav>
                    </div>
                </section>
                <div class="is-fullwidth has-text-centered" *ngIf="!ctrl.datosCargados">
                    <br>
                    <span class="tag is-primary is-large ">
                        <span class="icon">
                            <i class="icon-worldwide fa-spin"></i>
                        </span> &nbsp;
                        <span>Cargando...</span>
                    </span>
                </div>
                <section  style="padding: 1rem !important; overflow:auto; height: 100%;" >

                    <div class="notification is-danger" *ngIf="error_venta">
                        ¡No se completo la inscripción!
                        <strong>Intente de nuevo</strong>, Si no contacte con soporte
                    </div>
                    <div class="notification is-success" *ngIf="venta_ok">
                        Inscripción realizada con exito
                        <strong>Puede seguir agregando más</strong>
                    </div>
                    <div class="notification is-warning" *ngIf="documentos_no">
                        Los documentos no estan validados
                        <strong>No se puede hacer el pago</strong>
                    </div>
                    <div *ngIf="preinscripciones.preinscripciones_metadatos?.nombre != ''">
                        <section class="hero is-info">
                            <div class="hero-head">
                                <nav class="level">
                                    <!-- Left side -->
                                    <div class="level-left">
                                        <div class="level-item">
                                            <p class="title is-4" style=" padding: 10px; ">
                                                <span class="icon is-medium">
                                                    <i class="icon-id-card2"></i>
                                                </span>
                                                Datos del Alumno
                                            </p>
                                        </div>
                                    </div>
                                    <div class="level-right">
                                        <div class="level-item">
                                            <strong class="title is-4" style=" padding: 10px; " *ngIf="preinscripciones.folio">
                                                FOLIO: {{preinscripciones.folio}}
                                            </strong>
                                        </div>
                                    </div>
                                </nav>
                            </div>

                        </section>
                        <div class="hero-body">
                            <div class="columns">
                                <div class="column is-6">
                                    <label class="label">Nombre:</label> {{preinscripciones?.nombre_completo}}
                                </div>
                                <div class="column is-6">
                                    <label class="label">Email:</label> {{preinscripciones.email}}
                                </div>
                            </div>
                            <div class="columns">
                                <div class="column is-6">
                                    <label class="label">Curp:</label> {{preinscripciones?.curp}}
                                </div>
                                <div class="column is-6">
                                    <label class="label">Telefono:</label> {{preinscripciones?.telefono}}
                                </div>
                            </div>
                        </div>
                        <section class="hero is-link">
                            <div class="hero-head">
                                <nav class="level">
                                    <!-- Left side -->
                                    <div class="level-left">
                                        <div class="level-item">
                                            <p class="title is-4" style=" padding: 10px; ">
                                                <span class="icon is-medium">
                                                    <i class="fa fa-graduation-cap"></i>
                                                </span>
                                                Datos acádemicos
                                            </p>
                                        </div>
                                    </div>
                                </nav>
                            </div>

                        </section>
                        <div class="hero-body">
                            <div class="columns">
                                <div class="column is-6">
                                    <label class="label">Carrera:</label> {{preinscripciones.carreras?.nombre}}
                                </div>
                                <div class="column is-6">
                                    <label class="label">Modalidad:</label> {{preinscripciones.modalidades?.nombre}}
                                </div>
                            </div>
                            <div class="columns">
                                <div class="column is-6">
                                    <label class="label">Grupo:</label> {{preinscripciones.grupos?.clave}} {{preinscripciones.grupos?.nivel}} {{preinscripciones.grupos?.identificador}}
                                </div>
                                <div class="column is-6">
                                  <label class="label">Beca:</label>{{ preinscripciones.becas ? preinscripciones.becas.becas.nombre : "Sin beca" }}
                                </div>
                            </div>
                            <div class="columns">
                                <div class="column is-12">
                                    <div class="field">
                                        <div class="content">
                                            <span class="subtitle has-text-primary">

                                                <div class="b-checkbox is-info">
                                                    <input id="doct_v" class="styled"  disabled  type="checkbox" [checked]="preinscripciones.documentos_validados"  [checked]="preinscripciones.documentos_validados == 1 ? true : false">
                                                    <label for="doct_v">
                                                        <i class="fa fa-file is-size-4 has-text-grey-light"> </i> Documentos Validados {{preinscripciones.documentos_validados
                                                        ? 'SI': 'NO'}}
                                                    </label>
                                                </div>
                                            </span>
                                        </div>
                                        <div>
                                            <div class="columns">
                                                <div class="column is-8">
                                                    <label class="label">Preparatoria</label>
                                                </div>
                                                <div class="column is-4">
                                                    <label class="label">Tipo de beca</label>
                                                </div>
                                            </div>
                                            <div class="columns">
                                                <div class="column is-4">
                                                    <div class="field">
                                                        <div class="b-checkbox is-info">
                                                            <input id="acta_nacimiento" class="styled"  disabled [checked]="preinscripciones.preinscripciones_metadatos?.acta_nacimiento == '1' ? true : false"
                                                                type="checkbox">
                                                            <label for="acta_nacimiento">
                                                                Acta de nacimiento
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <br>
                                                    <div class="field">
                                                        <div class="b-checkbox is-info">
                                                            <input id="curp_impreso" class="styled"  disabled [checked]="preinscripciones.preinscripciones_metadatos?.curp_impreso == '1' ? true : false"
                                                                type="checkbox">
                                                            <label for="curp_impreso">
                                                                CURP
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <br>
                                                    <div class="field">
                                                        <div class="b-checkbox is-info">
                                                            <input id="certificado_preparatoria" class="styled"  disabled [checked]="preinscripciones.preinscripciones_metadatos?.certificado_preparatoria == '1' ? true : false"
                                                                type="checkbox">
                                                            <label for="certificado_preparatoria">
                                                                Certificado de preparatoria
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <br>
                                                    <div class="field">
                                                        <div class="b-checkbox is-info">
                                                            <input id="certificado_legalizado" class="styled"  disabled [checked]="preinscripciones.preinscripciones_metadatos?.certificado_legalizado == '1' ? true : false"
                                                                type="checkbox">
                                                            <label for="certificado_legalizado">
                                                                Certificado legalizado
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="column is-4">
                                                    <div class="field">
                                                        <div class="b-checkbox is-info">
                                                            <input id="certificado_medico" class="styled"  disabled [checked]="preinscripciones.preinscripciones_metadatos?.certificado_medico == '1' ? true : false"
                                                                type="checkbox">
                                                            <label for="certificado_medico">
                                                                Certificado médico
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <br>
                                                    <div class="field">
                                                        <div class="b-checkbox is-info">
                                                            <input id="carta_conducta" class="styled"  disabled [checked]="preinscripciones.preinscripciones_metadatos?.carta_conducta == '1' ? true : false"
                                                                type="checkbox">
                                                            <label for="carta_conducta">
                                                                Carta de buena conducta
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <br>
                                                    <div class="field">
                                                        <div class="b-checkbox is-info">
                                                            <input id="historial_academico" class="styled"  disabled [checked]="preinscripciones.preinscripciones_metadatos?.historial_academico == '1' ? true : false"
                                                                type="checkbox">
                                                            <label for="historial_academico">
                                                                Historial académico
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <br>
                                                    <div class="field">
                                                        <div class="b-checkbox is-info">
                                                            <input id="fotografias" class="styled"  disabled [checked]="preinscripciones.preinscripciones_metadatos?.fotografias == '1' ? true : false"
                                                                type="checkbox">
                                                            <label for="fotografias">
                                                                4 fotografías
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="column is-4">
                                                    <div class="field">
                                                        <div class="b-checkbox is-info">
                                                            <input id="beca_convenio" class="styled"  disabled [checked]="preinscripciones.preinscripciones_metadatos?.beca_convenio == '1' ? true : false"
                                                                type="checkbox">
                                                            <label for="beca_convenio">
                                                                Convenio
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <br>
                                                    <div class="field">
                                                        <div class="b-checkbox is-info">
                                                            <input id="beca_promedio" class="styled"  disabled [checked]="preinscripciones.preinscripciones_metadatos?.beca_promedio == '1' ? true : false"
                                                                type="checkbox">
                                                            <label for="beca_promedio">
                                                                Promedio
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <br>
                                                    <div class="field">
                                                        <label class="label">Observaciones:</label>
                                                        {{preinscripciones.preinscripciones_metadatos?.documentos_observaciones}}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </section>
            </div>
        </div>

        <!-- datos del cliente y los importes -->
        <div class="column is-one-third" style="padding:0em; width:22%">

            <div style="background: #FFF; border-radius: 0em; ">

                <section class="hero is-primary">
                    <div class="hero-head">
                        <nav class="level">
                            <!-- Left side -->
                            <div class="level-left">
                                <div class="level-item">
                                    <p class="title is-4" style=" padding-left: 10px; ">
                                        <span *ngIf="ctrl.cargando || cargando" class="icon is-medium">
                                            <i class="icon-worldwide fa-spin"></i>
                                        </span>
                                    </p>
                                </div>
                            </div>

                            <!-- Right side -->
                            <div class="level-right">

                              <a class="navbar-item is-primary tooltip" (click)="ctrl.abrirModal('pagosPublicos')">
                                <span class="icon fa-2x"> <i class="icon-search3"> </i> </span>
                                <span class="tooltiptext">Pagos publicos</span>
                              </a>

                                <a class="navbar-item is-primary tooltip" (click)="ctrl.regresar()">
                                    <span class="icon fa-2x">
                                        <i class="icon-back"> </i>
                                    </span>
                                    <span class="tooltiptext">Regresar</span>
                                </a>

                                <a class="navbar-item is-primary tooltip" (click)="ctrl.cargarDatos()" id='cargar_datos_actualizar' *ngIf="ctrl.id">
                                    <span class="icon fa-2x">
                                        <i class="icon-worldwide"></i>
                                    </span>
                                    <span class="tooltiptext">Actualizar</span>
                                </a>

                                <a class="navbar-item is-primary tooltip" routerLink="{{url_nuevo}}" *ngIf="ctrl.id">
                                    <span class="icon fa-2x">
                                        <i class="icon-file"></i>
                                    </span>
                                    <span class="tooltiptext">Nuevo</span>
                                </a>

                                <button class="navbar-item  tooltip" type="button" id="imprimirTicket" (click)="ctrl.imprimeTicket(movimiento)" *ngIf="reimprimir">
                                    <span class="icon fa-2x has-text-info">
                                        <i class="icon-printer2"> </i>
                                    </span>
                                    <span class="tooltiptext">Reimprimir el ticket</span>
                                </button>

                                <button class="navbar-item  tooltip" type="button" (click)="abrir_facturacion();" *ngIf="ctrl.dato.get('pagos_publicos_id').value == ''">
                                  <span class="icon fa-2x has-text-info">
                                    <i class="icon-invoice"> </i>
                                  </span>
                                  <span class="tooltiptext">Facturación</span>
                                </button>

                                <button class="navbar-item  tooltip" type="button" [ngClass]="{'is-loading': cargando}" [disabled]="ctrl.dato.invalid || cargando"
                                    *ngIf="!pago_completado" (click)="ctrl.abrirModal('confirmarLiquidacion')">
                                    <span class="icon fa-2x has-text-success">
                                        <i class="icon-diskette"> </i>
                                    </span>
                                    <span class="tooltiptext">Guardar</span>
                                </button>


                            </div>
                        </nav>
                    </div>
                </section>

                <div style="padding: 1em;">

                    <!-- cargar los catalogos que se requieran parametro 1 modelo donde se guarda el catalogo, parametro 2 ruta de la api -->
                    <a id="catalogos" (click)="ctrl.cargarCatalogo('cuentas_bancarias', 'cuenta-bancaria'); ctrl.cargarCatalogo('catalogos_usos_cfdis', ctrl.CFDI_PATH+'/api/v1/catalogo-uso-cfdi'); ctrl.cargarCatalogo('clientes', 'cliente?id=2'); ctrl.cargarCatalogo('metodos_pagos', 'tipo-metodo-pago'); ctrl.cargarCatalogo('formas_pagos', 'tipo-forma-pago'); ctrl.cargarCatalogo('logos64', 'logos64', 'logo64');"></a>
                    <a id="logo64" (click)="asignarLogos(ctrl.logos64); "></a>
                    <a id="recargar" (click)="cargarPreinscripcion(ctrl.dato.get('preinscripciones').value); asignar_factura(ctrl.facturacion)"></a>
                    <h3 class="title">
                        <i class="icon-file"></i> Datos del pago
                    </h3>

                    <div class="notification is-warning" *ngIf="!caja_abierta && ctrl.configuracion.sucursal.notificar_caja_cerrada">
                        ¡No se ha detectado ninguna caja abierta!
                        <strong>Puede realizar el pago</strong>, Pero se recomienda que se abra la caja o seleccione una si hay abierta
                        <a *ngIf="!tieneid" class="button is-small" routerLink="../../caja-operacion/nuevo">Abrir una caja</a>
                        <a *ngIf="tieneid" class="button is-small" routerLink="../../../caja-operacion/nuevo">Abrir una caja</a>
                    </div>

                    <div class="columns" *ngIf="!caja_abierta">
                      <div class="column is-12">
                        <div class="field">
                          <label class="label">Caja:</label>
                          <div class="select" style="float:right">
                            <select class="select" formControlName="cajas_id">
                              <option value="">Ninguna</option>
                              <option *ngFor="let val of ctrl.cajas" value="{{val.id}}">{{ val.cajas.nombre }}</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="columns" *ngIf="ctrl.dato.get('pagos_publicos_id').value == ''">
                      <div class="column is-12">
                        <div class="field">
                          <div class="b-checkbox is-info">
                            <input id="requiere_factura" class="styled" type="checkbox" formControlName="requiere_factura" [checked]="ctrl.dato.get('requiere_factura').value" />
                            <label for="requiere_factura"> Requiere factura? </label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="columns" *ngIf="ctrl.dato.get('requiere_factura').value == 1">
                      <div class="column is-12">
                        <div class="field">
                          <label class="label">Uso CFDI:</label>
                          <div class="select" style="float:right">
                            <select class="select" formControlName="uso_cfdi">
                              <option *ngFor="let item of ctrl.catalogos_usos_cfdis" value="{{item.clave}}">{{ item.nombre }}</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="columns" *ngIf="ctrl.dato.get('requiere_factura').value == 1">
                      <div class="column is-12">
                        <button class="button is-primary" type="button" (click)="ctrl.abrirModal('cambiar_rfc')">
                          Cambiar RFC {{ alumnos.factura_rfc.rfc }}
                        </button>
                      </div>
                    </div>
                    <div class="columns" *ngIf="ctrl.dato.get('requiere_factura').value == 2">
                      <div class="column is-12">
                        <div class="field">
                          <div class="b-checkbox is-info">
                            <input id="factura_pendiente" class="styled" type="checkbox" formControlName="pendiente_factura" [checked]="ctrl.dato.get('pendiente_factura').value" />
                            <label for="factura_pendiente"> Dejar pendiente </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="card">
                        <header class="card-header">
                            <div class="card-header-title">

                            </div>
                            <a class="card-header-icon">
                                <span class="icon fa-2x">
                                    <i class="icon-money3"></i>
                                </span>
                            </a>
                        </header>
                        <div class="card-content">

                            <div class="column is-12">
                              <div class="field">
                                <label class="label">Cuenta bancaria:</label>
                                <div class="control has-icons-left has-icons-right">
                                  <div class="select">
                                    <select class="select" formControlName="cuentas_bancarias_id">
                                      <option value="">Seleccione</option>
                                      <option *ngFor="let item of ctrl.cuentas_bancarias" value="{{item.id}}">Banco: {{item.banco.nombre }} Clabe:
                                        {{item.clabe}} - No. Cuenta:
                                        {{item.no_cuenta}}</option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div formArrayName="pagos">
                                <div class="content" *ngFor="let item of ctrl.dato.controls.pagos.controls; let i=index">
                                    <div [formGroupName]="i" [style.background]="item.value.es_abono ? 'gainsboro' : ''">
                                        <article class="media">

                                            <div class="media-content">
                                                <div style="display:flow-root">
                                                    <strong *ngIf="item.value.es_abono" style="float:left">
                                                        ABONO DE PEDIDO
                                                    </strong>
                                                </div>
                                                <div class="columns">



                                                    <div class="column is-12">
                                                        <label>Forma de pago: </label>
                                                        <div class="select">
                                                            <select class="select" name="tipos_formas_pagos_id" formControlName="tipos_formas_pagos_id" (change)="validar_cantidad_pago(
                                    $event,
                                    ctrl.dato.controls.pagos.controls[i]
                                      .controls.paga_con,
                                    ctrl.dato.get('pagos').value[i].importe,
                                    'min',
                                    i
                                  )">
                                                                <option *ngFor="let val of ctrl.formas_pagos" value="{{val.id}}">{{ val.nombre }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                  </div>
                                                  <div class="columns">
                                                    <div class="column is-12">

                                                        <label>TOTAL A PAGAR: </label>
                                                        <p class="control has-icons-left has-icons-right">
                                                            <span class="input has-text-centered is-success" style="background: green;  font-size: 1.5em;  color: white;">
                                                              {{ ctrl.dato.get('pagos').value[i].importe | currency: ctrl.configuracion.sucursal.moneda }}
                                                            </span>

                                                            <span class="icon is-small is-right" *ngIf="!item.controls.importe.valid">
                                                                <i class="fa fa-warning"></i>
                                                            </span>
                                                            <span class="help is-danger" *ngIf="!item.controls.importe.valid">Este campo es requerido.</span>
                                                        </p>
                                                    </div>

                                                </div>
                                                <div class="columns">
                                                    <div class="column is-12">
                                                        <label>Paga con: </label>
                                                        <p class="control has-icons-left has-icons-right" *ngIf="!item.value.es_abono">
                                                            <input class="input has-text-centered is-warning" (keyup)="validar_cantidad_pago($event, ctrl.dato.controls.pagos.controls[i].controls.paga_con, ctrl.dato.get('pagos').value[i].importe, 'min', i); "
                                                                type="number" step="0.1" min="{{ctrl.dato.get('pagos').value[i]?.importe}}"
                                                                placeholder="Paga con" formControlName="paga_con" [readonly]="ctrl.dato.get('pagos_publicos_id').value != ''">

                                                            <button *ngIf="ctrl.dato.get('pagos_publicos_id').value != ''" class="button is-danger is-fullwidth" (click)="quitarPagosPublicos()">
                                                              <i class="icon-trash"></i>Quitar pago publico
                                                            </button>
                                                        </p>
                                                        <p class="control has-icons-left has-icons-right" *ngIf="item.value.es_abono">
                                                            <input class="input has-text-centered is-warning" type="text" placeholder="Paga con" formControlName="paga_con" readonly>
                                                        </p>
                                                    </div>
                                                  </div>
                                                  <div class="columns">
                                                    <div class="column is-12">
                                                        <label>Cambio: </label>
                                                        <p class="control has-icons-left has-icons-right">
                                                          <span class="input has-text-centered is-dark">{{ ctrl.dato.get("cambio").value | currency:
                                                            ctrl.configuracion.sucursal.moneda }}</span>
                                                        </p>
                                                    </div>
                                                </div>
                                                <div class="columns">
                                                    <div class="column is-12">
                                                        <label>Metodo de pago: </label>
                                                        <div class="select">
                                                            <select class="select" name="tipos_metodos_pagos_id" formControlName="tipos_metodos_pagos_id">
                                                                <option *ngFor="let val of ctrl.metodos_pagos" value="{{val.id}}">{{ val.nombre }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </article>
                                    </div>
                                </div>
                            </div>
                            <div class="column is-12" *ngIf="ctrl.dato.get('cambio').value > 0">
                              <div class="field">
                                <div class="b-checkbox is-info">
                                  <input id="devolucion_cambio" class="styled" type="checkbox" formControlName="devolucion_cambio" [checked]="ctrl.dato.get('devolucion_cambio').value" />
                                  <label for="devolucion_cambio"> Se devolverá el cambio? </label>
                                </div>
                              </div>
                            </div>
                        </div>
                    </div>

                    <nav class="panel" style="font-size:1em">
                        <p class="panel-heading">
                            Cobro
                        </p>

                        <a class="panel-block is-active">
                            <span class="panel-icon">
                                <i class="icon-money3"></i>
                            </span>
                            <div class="columns" style="width:100%">
                                <div class="column is-6">
                                    Subtotal:
                                </div>
                                <div class="column is-6">
                                    {{ctrl.dato.get('subtotal').value | currency:ctrl.configuracion.sucursal.moneda}}
                                </div>
                            </div>
                        </a>
                        <a class="panel-block" *ngIf="ctrl.dato.get('descuento').value > 0">
                            <span class="panel-icon">
                                <i class="icon-money3"></i>
                            </span>
                            <div class="columns" style="width:100%">
                                <div class="column is-6">
                                    Descuento:
                                </div>
                                <div class="column is-6">
                                    {{ctrl.dato.get('descuento').value | currency:ctrl.configuracion.sucursal.moneda}}
                                </div>
                            </div>
                        </a>
                        <a class="panel-block" *ngIf="ctrl.dato.get('recargo').value > 0">
                          <span class="panel-icon">
                            <i class="icon-money3"></i>
                          </span>
                          <div class="columns" style="width:100%">
                            <div class="column is-6">
                              Recargo:
                            </div>
                            <div class="column is-6">
                              {{ctrl.dato.get('recargo').value | currency:ctrl.configuracion.sucursal.moneda}}
                            </div>
                          </div>
                        </a>
                        <a class="panel-block" *ngIf="ctrl.dato.get('iva').value > 0">
                            <span class="panel-icon">
                                <i class="icon-money3"></i>
                            </span>
                            <div class="columns" style="width:100%">
                                <div class="column is-6">
                                    Iva:
                                </div>
                                <div class="column is-6">
                                    {{ctrl.dato.get('iva').value | currency:ctrl.configuracion.sucursal.moneda}}
                                </div>
                            </div>
                        </a>
                        <a class="panel-block">
                            <span class="panel-icon">
                                <i class="icon-money3"></i>
                            </span>
                            <div class="columns" style="width:100%">
                                <div class="column is-6">
                                    Total:
                                </div>
                                <div class="column is-6">
                                    {{ctrl.dato.get('total').value | currency:ctrl.configuracion.sucursal.moneda}}

                                    <span *ngFor="let moneda of ctrl.configuracion.sucursal.conversiones_monedas" class="tag">

                                        <strong>
                                            <font>{{moneda.nombre}}</font>

                                        </strong>
                                        <font>
                                            {{(ctrl.dato.get('total').value / moneda.tipo_cambio) | currency:ctrl.configuracion.sucursal.moneda}}
                                        </font>
                                    </span>
                                </div>
                            </div>
                        </a>
                        <a class="panel-block" *ngIf="ctrl.dato.get('total_recibido').value > 0">
                            <span class="panel-icon">
                                <i class="icon-money3"></i>
                            </span>
                            <div class="columns" style="width:100%">
                                <div class="column is-6">
                                    Total recibido:
                                </div>
                                <div class="column is-6">
                                    {{ctrl.dato.get('total_recibido').value | currency:ctrl.configuracion.sucursal.moneda}}
                                </div>
                            </div>
                        </a>
                        <a class="panel-block" *ngIf="ctrl.dato.get('cambio').value > 0">
                            <span class="panel-icon">
                                <i class="icon-money3"></i>
                            </span>
                            <div class="columns" style="width:100%">
                                <div class="column is-6">
                                    Cambio:
                                </div>
                                <div class="column is-6">
                                    {{ctrl.dato.get('cambio').value | currency:ctrl.configuracion.sucursal.moneda}}

                                    <span *ngFor="let moneda of ctrl.configuracion.sucursal.conversiones_monedas" class="tag">

                                        <strong>
                                            <font>{{moneda.nombre}}</font>

                                        </strong>
                                        <font>
                                            {{(ctrl.dato.get('cambio').value / moneda.tipo_cambio) | currency:ctrl.configuracion.sucursal.moneda}}
                                        </font>

                                    </span>
                                </div>
                            </div>
                        </a>
                    </nav>

                </div>
            </div>
        </div>

    </div>
</form>

<div class="modal" id="confirmarLiquidacion">
    <div class="modal-background"></div>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">
                <i class="fa fa-warning"></i> Alerta</p>
            <button class="delete" (click)="ctrl.cancelarModal('confirmarLiquidacion')"></button>
        </header>
        <section class="modal-card-body">
            <div class="content">
                <h1>¿Esta seguro de generar el pago?</h1>
                <p>Ya no se podra editar la información una vez guardada</p>


                <nav class="panel" style="font-size:1em">
                    <p class="panel-heading">
                        Pago: {{ctrl.dato.get('requiere_factura').value == 1 ? 'Factura requirida': 'No requiere factuta'}}
                    </p>

                    <a class="panel-block is-active">
                        <span class="panel-icon">
                            <i class="icon-money3"></i>
                        </span>
                        <div class="columns" style="width:100%">
                            <div class="column is-6">
                                Subtotal:
                            </div>
                            <div class="column is-6">
                                {{ctrl.dato.get('subtotal').value | currency:ctrl.configuracion.sucursal.moneda}}
                            </div>
                        </div>
                    </a>
                    <a class="panel-block" *ngIf="ctrl.dato.get('descuento').value > 0">
                        <span class="panel-icon">
                            <i class="icon-money3"></i>
                        </span>
                        <div class="columns" style="width:100%">
                            <div class="column is-6">
                                Descuento:
                            </div>
                            <div class="column is-6">
                                {{ctrl.dato.get('descuento').value | currency:ctrl.configuracion.sucursal.moneda}}
                            </div>
                        </div>
                    </a>
                    <a class="panel-block" *ngIf="ctrl.dato.get('iva').value > 0">
                        <span class="panel-icon">
                            <i class="icon-money3"></i>
                        </span>
                        <div class="columns" style="width:100%">
                            <div class="column is-6">
                                Iva:
                            </div>
                            <div class="column is-6">
                                {{ctrl.dato.get('iva').value | currency:ctrl.configuracion.sucursal.moneda}}
                            </div>
                        </div>
                    </a>
                    <a class="panel-block">
                        <span class="panel-icon">
                            <i class="icon-money3"></i>
                        </span>
                        <div class="columns" style="width:100%">
                            <div class="column is-6">
                                Total:
                            </div>
                            <div class="column is-6">
                                {{ctrl.dato.get('total').value | currency:ctrl.configuracion.sucursal.moneda}}
                            </div>
                        </div>
                    </a>
                    <a class="panel-block" *ngIf="ctrl.dato.get('total_recibido').value > 0">
                        <span class="panel-icon">
                            <i class="icon-money3"></i>
                        </span>
                        <div class="columns" style="width:100%">
                            <div class="column is-6">
                                Total recibido:
                            </div>
                            <div class="column is-6">
                                {{ctrl.dato.get('total_recibido').value | currency:ctrl.configuracion.sucursal.moneda}}
                            </div>
                        </div>
                    </a>
                    <a class="panel-block" *ngIf="ctrl.dato.get('cambio').value > 0">
                        <span class="panel-icon">
                            <i class="icon-money3"></i>
                        </span>
                        <div class="columns" style="width:100%">
                            <div class="column is-6">
                                Cambio:
                            </div>
                            <div class="column is-6">
                                {{ctrl.dato.get('cambio').value | currency:ctrl.configuracion.sucursal.moneda}}
                            </div>
                        </div>
                    </a>
                </nav>


            </div>
        </section>
        <footer class="modal-card-foot">
            <a class="button is-success" (click)="enviar()" [ngClass]="{'is-loading': borrarCargando}">Continuar</a>
            <a class="button" (click)="ctrl.cancelarModal('confirmarLiquidacion')">Cancelar</a>
        </footer>
    </div>
</div>

<div id="banner" align="center" *ngIf="ctrl.cargando || ctrl.cargarDatosCatalogo">
    <div class="bloquear-azul">

    </div>
    <span class="tag is-primary is-large " style="position: absolute; top: 45%; font-size: 2em; z-index: 999999999;  left: 45%;">
        <span class="icon">
            <i class="icon-worldwide fa-spin"></i>
        </span> &nbsp;
        <span>Cargando...</span>
    </span>
</div>


<div class="modal" id="cambiar_rfc">
  <div class="modal-background"></div>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title"><i class="fa fa-credit-card"></i> Seleccione el RFC a utilizar en la facturación</p>
      <button class="delete" (click)="ctrl.cancelarModal('cambiar_rfc')"></button>
    </header>
    <section class="modal-card-body">
      <table class="table is-striped  is-fullwidth">
        <thead>
          <tr>
            <th># </th>
            <th>RFC</th>
            <th>RAZON SOCIAL </th>
            <th>CODIGO POSTAL</th>

          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let val of alumnos?.personas_rfcs; let xi = index">
            <td>{{ xi + 1 }}</td>
            <td>
              <div class="field">
                <div class="b-checkbox is-info">
                  <input id="rfc_cambio{{xi}}" class="styled" (click)="cambiar_rfc(val)" type="checkbox" [checked]="val.rfc == alumnos.factura_rfc.rfc ? true : false" />
                  <label for="rfc_cambio{{xi}}">{{ val.rfc }}</label>
                </div>
              </div>
            </td>
            <td>{{ val.razon_social }}</td>
            <td>{{ val.codigo_postal }}</td>
          </tr>
        </tbody>
      </table>

    </section>
    <footer class="modal-card-foot">
      <a class="button" (click)="ctrl.cancelarModal('cambiar_rfc')">Ok</a>
    </footer>
  </div>
</div>


<!-- ////////////////////////////////////////////////////// Facturacion /////////////////-->
<div class="modal" id="verPdf">
  <div class="modal-background"></div>
  <div class="modal-card" style="width:80%">
    <header class="modal-card-head">
      <div class="modal-card-title">
        <nav class="level">
          <!-- Left side -->
          <div class="level-left">
            <div class="level-item">
              <p class="subtitle is-5">
                <strong>Facturación {{facturacion.Version}} </strong>
              </p>
            </div>
          </div>

          <!-- Right side -->
          <div class="level-right">
            <p class="level-item">
              <a class=" navbar-item tooltip" id="imprimir_pdf" (click)="ctrl.imprimeFactura(facturacion, logo)">
                <span class="icon fa-2x">
                  <i class="icon-printer2"></i>
                </span>
                <span class="tooltiptext is-hidden-touch">&nbsp; Imprimir</span>
              </a>

              <button class="navbar-item is-success tooltip" (click)="ctrl.abrirModal('confirmarTimbrar')" [disabled]="cargando"
                *ngIf="valido">
                <span class="icon fa-2x has-text-black">
                  <i class="fa fa-qrcode"></i>
                </span>
                <span class="tooltiptext is-hidden-touch">&nbsp; Timbrar</span>
              </button>

              <a class=" navbar-item"></a>
            </p>
          </div>
        </nav>
      </div>
      <button class="delete" (click)="ctrl.cancelarModal('verPdf')"></button>
    </header>
    <section class="modal-card-body" *ngIf="facturacion_inicio">

      <div class="box">
        <article class="media">
          <div class="media-content">
            <section class="hero is-primary">
              <div class="hero-body">
                <nav class="level">
                  <div class="columns">
                    <div class="column is-9">
                      Uso CFDI:
                      <div class="select" style="float:right">
                        <select class="select" [(ngModel)]="facturacion.Receptor.UsoCFDI" [ngModelOptions]="{standalone: true}">
                          <option *ngFor="let item of ctrl.catalogos_usos_cfdis" value="{{item.clave}}">{{item.nombre}}</option>
                        </select>
                      </div>
                    </div>
                    <div class="column is-6">
                      Impuestos:
                      <hr style="border: none; margin: 0.5rem 0; height: 0px;">
                      <div class="b-checkbox is-large" style="float:left">
                        <input id="seleccionar_iva" class="styled" type="checkbox" [(ngModel)]="seleccionar_iva">
                        <label for="seleccionar_iva">
                          {{seleccionar_iva ? 'Seleccionar productos con iva' : 'Todos los productos con iva'}}
                        </label>
                      </div>
                    </div>
                  </div>
                </nav>
              </div>
            </section>

            <div class="notification is-danger" *ngIf="error_timbre">
              ¡Ocurrio un error al intentar timbrar la factura!
              <strong>Por favor</strong>, intentelo de nuevo
            </div>
            <div class="notification is-danger" *ngIf="error_busqueda">
              ¡Ocurrio un error al intentar buscar!
              <strong>Por favor</strong>, intentelo de nuevo
            </div>
            <div class="notification is-black" *ngIf="sin_resultado != ''">
              ¡Mesaje del servidor!
              <strong>{{sin_resultado}}</strong>
            </div>
            <div *ngIf="errores.length > 0">
              <div class="notification is-danger" *ngFor="let msg of errores;">
                <font size="6pt">{{msg.codigo}}</font> {{msg.mensaje}}
                <strong>{{msg.fecha | formatoFecha}}</strong>
              </div>
            </div>
            <div class="is-fullwidth has-text-centered" *ngIf="cargando">
              <br>
              <span class="tag is-primary is-large ">
                <span class="icon">
                  <i class="icon-worldwide fa-spin"></i>
                </span> &nbsp;
                <span>Cargando...</span>
              </span>
              <br>
              <br>
            </div>
            <br>
            <div id="imprimir_factura">
              <article class="media">
                <div class="media-content">
                  <div>
                    <!-- emisor -->
                    <div class="columns">
                      <div class="column is-2">
                        <figure class="image is-1by1 figure-border logo">
                          <img [src]="ctrl.configuracion.sucursal.logo ? ctrl.API_PATH+'/adjunto/configuracion/'+ ctrl.configuracion.sucursal.logo : ctrl.configuracion.empresa.logo ? ctrl.API_PATH+'/adjunto/configuracion/'+ ctrl.configuracion.empresa.logo : './assets/yoursoft.png'">
                        </figure>
                      </div>

                      <div class="column is-6">
                        <div class="box">
                          <article class="media">
                            <div class="media-content">
                              <div class="content">
                                <p>
                                  <strong>Folio fiscal: </strong>
                                  {{facturacion.Complemento.TimbreFiscalDigital.UUID}}
                                </p>
                                <p>
                                  <strong>No. de serie del CSD: </strong>
                                  {{facturacion.NoCertificado}}
                                </p>
                                <p>
                                  <strong>No. de serie del certificado SAT: </strong>
                                  {{facturacion.Complemento.TimbreFiscalDigital.NoCertificadoSAT}}
                                </p>
                                <p>
                                  <strong>Fecha y hora de emisión: </strong>
                                  {{facturacion.Fecha }}
                                </p>
                                <p>
                                  <strong>Fecha y hora de certificación: </strong>
                                  {{facturacion.Complemento.TimbreFiscalDigital.FechaTimbrado}}
                                </p>
                              </div>
                            </div>
                          </article>
                        </div>
                      </div>

                      <div class="column is-4">
                        <div class="box">
                          <article class="media">
                            <div class="media-content">
                              <div class="content">
                                <p>
                                  <strong>Emisor: </strong>
                                  {{facturacion.Emisor.Nombre}}
                                </p>
                                <p>
                                  <strong>R.F.C.: </strong>
                                  {{facturacion.Emisor.Rfc}}
                                </p>
                                <p>
                                  <strong>Lugar de expedición: </strong>
                                  {{facturacion.LugarExpedicion}}
                                </p>
                                <p>
                                  <strong>Régimen fiscal: </strong>
                                  {{facturacion.Emisor.RegimenFiscal}}
                                </p>
                                <p>
                                  <strong>Tipo de comprobante: </strong>
                                  {{facturacion.TipoDeComprobante}}
                                </p>

                              </div>
                            </div>
                          </article>
                        </div>
                      </div>
                    </div>
                    <!-- datos del cliente -->
                    <div class="columns">
                      <div class="column is-8">
                        <div class="box">
                          <article class="media">
                            <div class="media-content">
                              <div class="content">
                                <p>
                                  <strong>Receptor:</strong>
                                  {{facturacion.Receptor.Nombre}}
                                </p>
                                <p>
                                  <strong>R.F.C.:</strong>
                                  {{facturacion.Receptor.Rfc}}
                                </p>
                              </div>
                            </div>
                          </article>
                        </div>
                      </div>
                      <div class="column is-4">
                        <div class="box">
                          <article class="media">
                            <div class="media-content">
                              <div class="content">
                                <p>
                                  <strong>Uso CFDI:</strong>
                                  {{facturacion.Receptor.UsoCFDI}}
                                </p>
                                <p>
                                  <strong>Folio y serie:</strong>
                                  {{facturacion.Folio}} {{facturacion.Serie}}
                                </p>
                              </div>
                            </div>
                          </article>
                        </div>
                      </div>
                    </div>
                    <!-- complemento educativo -->
                    <div class="columns" *ngIf="facturacion.Conceptos.Concepto.length > 0">
                      <div class="column is-12">
                        <div class="box">
                          <article class="media">
                            <div class="media-content">
                              <div class="content">
                                <table class="table is-striped  is-fullwidth">
                                  <thead>
                                    <tr>
                                      <th>IEDU Versión</th>
                                      <th>Alumno </th>
                                      <th>CURP </th>
                                      <th>Nivel</th>
                                      <th>RVOE </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>{{facturacion.Conceptos.Concepto[0].ComplementoConcepto.version}}</td>
                                      <td>{{facturacion.Conceptos.Concepto[0].ComplementoConcepto.nombreAlumno}}</td>
                                      <td>{{facturacion.Conceptos.Concepto[0].ComplementoConcepto.CURP}}</td>
                                      <td>{{facturacion.Conceptos.Concepto[0].ComplementoConcepto.nivelEducativo}}</td>
                                      <td>{{facturacion.Conceptos.Concepto[0].ComplementoConcepto.autRVOE}}</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </article>
                        </div>
                      </div>
                    </div>

                    <!-- detalle de los articulos -->
                    <div class="columns">
                      <div class="column is-12">
                        <div class="box">
                          <article class="media">
                            <div class="media-content">
                              <div class="content">
                                <table class="table is-striped  is-fullwidth">
                                  <thead>
                                    <tr>
                                      <th>Cve prod/serv </th>
                                      <th>No. Identificacion </th>
                                      <th>Cantidad </th>
                                      <th>Unidad</th>
                                      <th>Descripción </th>
                                      <th>Precio </th>
                                      <th>Descuento </th>
                                      <th>Impuesto </th>
                                      <th>Importe </th>
                                      <th *ngIf="seleccionar_iva" class="novisible">IVA?</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr *ngFor="let concepto of facturacion.Conceptos.Concepto; let i = index">
                                      <td>{{concepto.ClaveProdServ}}</td>
                                      <td>{{concepto.NoIdentificacion}}</td>
                                      <td>{{concepto.Cantidad}}</td>
                                      <td>{{concepto.ClaveUnidad}} {{concepto.Unidad}}</td>
                                      <td>{{concepto.Descripcion}}</td>
                                      <td>{{concepto.ValorUnitario | currency:ctrl.configuracion.sucursal.moneda}} </td>
                                      <td>{{concepto.Descuento | currency:ctrl.configuracion.sucursal.moneda}}</td>
                                      <td>
                                        <span *ngIf="concepto.Impuestos">
                                          <small *ngIf="concepto.Impuestos.Traslados.length > 0">Traslados</small>
                                          <span *ngFor="let traslado of concepto.Impuestos.Traslados">
                                            <strong>{{traslado.Traslado.Impuesto}} ({{traslado.Traslado.TipoFactor
                                              == 'Tasa' ? traslado.Traslado.TasaOCuota
                                              * 100 : traslado.Traslado.TasaOCuota}}%):
                                            </strong>
                                            {{traslado.Traslado.Importe | currency:ctrl.configuracion.sucursal.moneda}}
                                          </span>
                                        </span>

                                        <span *ngIf="concepto.Impuestos">
                                          <small *ngIf="concepto.Impuestos.Retenciones.length > 0">Retenciones</small>
                                          <span *ngFor="let retencion of concepto.Impuestos.Retenciones">
                                            <strong>{{retencion.Retencion.Impuesto}} ({{retencion.Retencion.TipoFactor
                                              == 'Tasa' ? retencion.Retencion.TasaOCuota
                                              * 100 : retencion.Retencion.TasaOCuota}}%):</strong>
                                            {{retencion.Retencion.Importe |
                                            currency:ctrl.configuracion.sucursal.moneda}}
                                          </span>
                                        </span>
                                      </td>
                                      <td>{{concepto.Importe | currency:ctrl.configuracion.sucursal.moneda}}</td>
                                      <td class="novisible" *ngIf="seleccionar_iva">
                                        <div class="b-checkbox is-large">
                                          <input id="con_iva{{i}}" class="styled" type="checkbox" [(ngModel)]="concepto.iva"
                                            (click)="quita_poner_iva(concepto)" (checked)="concepto.iva ? true: false">
                                          <label for="con_iva{{i}}">

                                          </label>
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>

                                </table>
                              </div>
                            </div>
                          </article>
                        </div>
                      </div>
                    </div>
                    <!-- pago -->
                    <div class="columns">
                      <div class="column is-8">
                        <div class="box">
                          <article class="media">
                            <div class="media-content">
                              <div class="content">
                                <div>
                                  <strong>Total con letra</strong>
                                  {{facturacion.Total | numeroLetra:configuracion.sucursal.moneda}}
                                  <hr class="hr">
                                </div>
                                <div class="columns">
                                  <div class="column is-6">
                                    <p>
                                      <strong>Moneda:</strong>
                                      {{facturacion.Moneda}}
                                    </p>
                                    <p>
                                      <strong>Forma de pago:</strong>
                                      {{facturacion.FormaPago}}
                                    </p>
                                  </div>
                                  <div class="column is-6">
                                    <p>
                                      <strong>Método de pago:</strong>
                                      {{facturacion.MetodoPago}}
                                    </p>
                                    <p>
                                      <strong>Condiciones de pago:</strong>
                                      <span class="sellos_sat" style="word-wrap: break-word; font-size:9pt;">
                                        {{facturacion.CondicionesDePago}}
                                      </span>
                                    </p>
                                  </div>
                                </div>

                              </div>
                            </div>
                          </article>
                        </div>
                      </div>
                      <div class="column is-4">
                        <div class="box">
                          <article class="media">
                            <div class="media-content">
                              <div class="content">
                                <p>
                                  <strong>Subtotal:</strong>
                                  {{facturacion.SubTotal | currency:ctrl.configuracion.sucursal.moneda}}
                                </p>
                                <p>
                                  <strong>Descuento:</strong>
                                  {{facturacion.Descuento | currency:ctrl.configuracion.sucursal.moneda}}
                                </p>
                                <div class="impuestos_fac" *ngIf="facturacion.Impuestos">

                                  <small *ngIf="facturacion.Impuestos.Traslados.length > 0">Traslados</small>
                                  <p *ngFor="let traslado of facturacion.Impuestos.Traslados">
                                    <strong>{{traslado.Traslado.Impuesto}} ({{traslado.Traslado.TipoFactor
                                      == 'Tasa' ? traslado.Traslado.TasaOCuota * 100 :
                                      traslado.Traslado.TasaOCuota}}%):</strong>
                                    {{traslado.Traslado.Importe | currency:ctrl.configuracion.sucursal.moneda}}

                                  </p>
                                </div>
                                <div class="impuestos_fac" *ngIf="facturacion.Impuestos">
                                  <small *ngIf="facturacion.Impuestos.Retenciones.length > 0">Retenciones</small>
                                  <p *ngFor="let retencion of facturacion.Impuestos.Retenciones">
                                    <strong>{{retencion.Retencion.Impuesto}} ({{retencion.Retencion.TipoFactor
                                      == 'Tasa' ? retencion.Retencion.TasaOCuota * 100 :
                                      retencion.Retencion.TasaOCuota}}%):</strong>
                                    {{retencion.Retencion.Importe | currency:ctrl.configuracion.sucursal.moneda}}

                                  </p>
                                </div>
                                <p>
                                  <strong>Total:</strong>
                                  {{facturacion.Total | currency:ctrl.configuracion.sucursal.moneda}}
                                </p>
                              </div>
                            </div>
                          </article>
                        </div>
                      </div>
                    </div>

                    <!-- qy y sellos -->
                    <div class="columns">
                      <div class="column is-2">
                        <figure class="image is-1by1 figure-border">
                          <img [src]="'data:image/png;base64,' + facturacion.Complemento.TimbreFiscalDigital.qr" *ngIf="facturacion.Complemento.TimbreFiscalDigital.qr != ''">
                          <img src="assets/qr.png" *ngIf="facturacion.Complemento.TimbreFiscalDigital.qr == ''">
                        </figure>
                      </div>
                      <div class="column is-10">
                        <div class="box">
                          <article class="media">
                            <div class="media-content">
                              <div class="content sellos">
                                <div>
                                  <strong>Sello digital del CFDI:</strong>
                                  <br>
                                  <div class="sellos_sat" style="word-wrap: break-word; font-size:8.5pt;">
                                    {{facturacion.Complemento.TimbreFiscalDigital.SelloCFD}}
                                  </div>
                                </div>
                                <div>
                                  <strong>Sello digital del SAT:</strong>
                                  <br>
                                  <div class="sellos_sat" style="word-wrap: break-word; font-size:8.5pt;">
                                    {{facturacion.Complemento.TimbreFiscalDigital.SelloSAT}}
                                  </div>
                                </div>
                                <div>
                                  <strong>Cadena original del complemento de certificación del SAT:
                                  </strong>
                                  <br>
                                  <div class="sellos_sat" style="word-wrap: break-word; font-size:8.5pt;">
                                    {{facturacion.Complemento.TimbreFiscalDigital.CadenaOriginal}}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </article>
                        </div>
                      </div>
                    </div>
                    <p align="center">
                      <strong>Este documento es una representación impresa de un CFDI versión {{VERSION_CFDI}}</strong>
                    </p>
                  </div>
                </div>
              </article>
            </div>
          </div>
        </article>
      </div>
    </section>
    <footer class="modal-card-foot">
      <a class="button" (click)="ctrl.cancelarModal('verPdf')">Cancelar</a>
    </footer>
  </div>
</div>


<div class="modal" id="confirmarTimbrar">
  <div class="modal-background"></div>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">
        <i class="fa fa-warning"></i> Confirmar</p>
      <button class="delete" (click)="ctrl.cancelarModal('confirmarTimbrar')"></button>
    </header>
    <section class="modal-card-body">
      <div class="content">
        <h1>¿Esta seguro de iniciar el proceso de timbrado?</h1>
        <p>Ya no se podra agregar más información a esta hoja</p>
      </div>
    </section>
    <footer class="modal-card-foot">
      <a class="button is-success" (click)="timbrar()">Continuar</a>
      <a class="button" (click)="ctrl.cancelarModal('confirmarTimbrar')">Cancelar</a>
    </footer>
  </div>
</div>


<div class="modal" id="pagosPublicos">
  <div class="modal-background"></div>
  <div class="modal-card" style="width:75%">
    <header class="modal-card-head">
      <p class="modal-card-title">
        <i class="fa fa-check"></i> Buscar pagos publicos
      </p>
      <button class="delete" (click)="ctrl.cancelarModal('pagosPublicos')"></button>
    </header>
    <section class="modal-card-body">
      <div class="content">
        <div class="field is-grouped">
          <div class="control has-icons-left is-expanded">
            <input type="text" class="input is-flat is-medium" placeholder="Buscar" #searchBox id="search-box" (keyup)="listarBusqueda(searchBox.value)">
            <span class="icon is-medium is-left">
              <i class="icon-search3"></i>
            </span>
          </div>
        </div>
        <div class="notification is-warning" *ngIf="seleccione_colegiatura != ''">{{seleccione_colegiatura}}</div>
        <table class="table is-striped  is-fullwidth">
          <thead>
            <tr>
              <th># </th>
              <th>Banco</th>
              <th>Fecha</th>
              <th>Sucursal </th>
              <th>Importe</th>
              <th>Facturado</th>
              <th>Reclamado por</th>
              <th>Observaciones</th>
              <th width="1%" class="no_pdf">Opciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of pagos_publicos; let i=index">
              <td style="vertical-align: middle;">{{i+1}} </td>
              <th style="vertical-align: middle;">{{ item.cuentas_bancarias.banco?.nombre }} (Cuenta: {{
                item.cuentas_bancarias.no_cuenta }}) </th>
              <td style="vertical-align: middle;">{{ item.fecha }} : {{ item.hora }}</td>
              <td style="vertical-align: middle;">{{ item.sucursal }}</td>
              <td style="vertical-align: middle;">{{ item.cantidad |
                currency:ctrl.configuracion.sucursal.moneda:'symbol' }}
              </td>
              <td style="vertical-align: middle;">{{ item.facturas_id ? 'Si' : 'No' }} </td>
              <td style="vertical-align: middle;">{{ item.personas_id ? persona.nombre : 'Nadie' }} </td>
              <td style="vertical-align: middle;">{{ item.observaciones }}</td>
              <td style="vertical-align: middle;" class="has-text-centered no_pdf">
                <div class="level-left">
                  <a class="navbar-item tooltip" (click)="asignarPagoPublico(item)">
                    <span class="icon fa-2x  has-text-primary">
                      <i class="icon-donation-5"></i>
                    </span>
                    <span class="tooltiptext">Asignar</span>
                  </a>
                </div>
              </td>

            </tr>
            <tr *ngIf="ctrl.dato.length == 0">
              <td colspan="5" style="vertical-align: middle; color:#888;">Esta lista está vacía.</td>
            </tr>
          </tbody>

        </table>
      </div>
    </section>
    <footer class="modal-card-foot">
      <a class="button" (click)="ctrl.cancelarModal('pagosPublicos')">Cerrar Ventana</a>
    </footer>
  </div>
</div>
